import { render, staticRenderFns } from "./HistoryFilters.vue?vue&type=template&id=471a97ba"
import script from "./HistoryFilters.vue?vue&type=script&lang=js"
export * from "./HistoryFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports